import React, { useState } from 'react';
import './WhatsAppFloat.css';

const WhatsAppFloat: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isMinimized, setIsMinimized] = useState(true);

    const phoneNumber = '919655007980'; // Replace with actual phone number
    const message = 'Hello! I am interested in your handwoven textiles. Can you please provide more information about your products?';

    const handleWhatsAppClick = () => {
        const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(url, '_blank');
    };

    const toggleChat = () => {
        if (isMinimized) {
            setIsMinimized(false);
            setIsOpen(true);
        } else {
            setIsOpen(!isOpen);
        }
    };

    const minimizeChat = () => {
        setIsMinimized(true);
        setIsOpen(false);
    };

    if (isMinimized) {
        return (
            <div className="whatsapp-float minimized" onClick={toggleChat}>
                <div className="whatsapp-icon">
                    <span>💬</span>
                </div>
            </div>
        );
    }

    return (
        <div className={`whatsapp-float ${isOpen ? 'open' : ''}`}>
            <div className="whatsapp-header">
                <button className="minimize-btn" onClick={(e) => { e.stopPropagation(); minimizeChat(); }}>−</button>
                <div className="whatsapp-info" onClick={toggleChat}>
                    <div className="whatsapp-avatar">📱</div>
                    <div className="whatsapp-details">
                        <h4>Namma Nesavu Nool</h4>
                        <p>Online</p>
                    </div>
                </div>
                <button className="close-btn" onClick={(e) => { e.stopPropagation(); toggleChat(); }}>×</button>
            </div>

            {isOpen && (
                <div className="whatsapp-content">
                    <div className="whatsapp-message">
                        <p>Hi! 👋</p>
                        <p>Welcome to Namma Nesavu Nool! How can we help you today?</p>
                    </div>

                    <div className="whatsapp-actions">
                        <button className="whatsapp-btn" onClick={handleWhatsAppClick}>
                            <span>💬</span>
                            Start Chat on WhatsApp
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default WhatsAppFloat;
